import Link from "next/link";
import {
  Badge,
  Box,
  Button,
  Grid,
  GridItem,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CheckCircle } from "lucide-react";
import { HOME_SECTION_IDS, PRICING_PLANS } from "./homeContent";
import { HomeCard, SectionContainer, SectionHeading, SectionShell } from "./homeUi";

export function HomePricing() {
  return (
    <SectionShell id={HOME_SECTION_IDS.planos} alt>
      <SectionContainer>
        <SectionHeading
          eyebrow="Planos"
          title="Escolha o plano ideal para o tamanho da sua barbearia"
          description="Teste grátis por 7 dias. Preços transparentes, sem surpresas."
        />

        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", xl: "repeat(4, 1fr)" }}
          gap={6}
          maxW="6xl"
          mx="auto"
        >
          {PRICING_PLANS.map((plan) => (
            <GridItem key={plan.name}>
              <HomeCard
                h="full"
                display="flex"
                flexDirection="column"
                borderColor={plan.highlight ? "orange.900" : "whiteAlpha.150"}
                borderWidth={plan.highlight ? "2px" : "1px"}
                position="relative"
              >
                {plan.badge ? (
                  <Badge
                    position="absolute"
                    top={0}
                    right={0}
                    bg="orange.900"
                    color="black"
                    py={1}
                    px={3}
                    borderRadius="0 16px 0 12px"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    {plan.badge}
                  </Badge>
                ) : null}

                <VStack align="start" spacing={4} flex="1">
                  <Heading as="h3" size="md" color="white">
                    {plan.name}
                  </Heading>
                  <Box>
                    <Text fontSize="3xl" fontWeight="bold" color="white">
                      {plan.price}
                    </Text>
                    {plan.period ? (
                      <Text color="barber.100" fontSize="sm">
                        {plan.period}
                      </Text>
                    ) : null}
                  </Box>

                  <List spacing={2} flex="1" w="full">
                    {plan.features.map((feature) => (
                      <ListItem key={feature} color="barber.100" fontSize="sm">
                        <ListIcon as={CheckCircle} color="orange.900" />
                        {feature}
                      </ListItem>
                    ))}
                  </List>

                  <Button
                    as={Link}
                    href={plan.ctaHref}
                    w="full"
                    size="md"
                    bg={plan.highlight ? "button.cta" : "transparent"}
                    color={plan.highlight ? "black" : plan.accent || "white"}
                    border={plan.highlight ? "none" : "1px solid"}
                    borderColor={plan.accent || "whiteAlpha.300"}
                    _hover={
                      plan.highlight
                        ? { opacity: 0.85 }
                        : { bg: plan.accent, color: "black" }
                    }
                  >
                    {plan.ctaLabel}
                  </Button>
                </VStack>
              </HomeCard>
            </GridItem>
          ))}
        </Grid>
      </SectionContainer>
    </SectionShell>
  );
}
